/**
 * Réglages de vue-i18n propres au site — fusionnés par `@nuxtjs/i18n` avec
 * ceux de la couche (`<couche>/i18n/i18n.config.ts`, qui garde ses messages).
 *
 * Les règles de pluriel sont posées pour les TROIS langues : sans règle `fr`,
 * vue-i18n mettrait 0 au pluriel (voir `lib/i18n/pluriels.mjs`).
 */
import { REGLES_PLURIEL } from '../lib/i18n/pluriels.mjs'

export default defineI18nConfig(() => ({
  legacy: false,
  pluralRules: REGLES_PLURIEL,
}))
